// extracted by mini-css-extract-plugin
export default {"bannerBg":"MainPage_bannerBg__HY+ZM"};